import { DistributionClass } from '@upright/common/model/distributions/types';
import { ImpactScoreIVKey, impactScoreKeys } from '@upright/common/model/output/scores/types';
import { useDistributionPercentilers } from '@upright/ui/api/model/distributions';
import { isNil } from 'lodash';

type Key = ImpactScoreIVKey | 'nir' | 'nis';
const keys: Key[] = ['nir', 'nis', ...impactScoreKeys] as const;

export function useImpactPercentiles(scores: Map<Key, number | undefined>, dClass: DistributionClass | undefined) {
  const distributionPercentilerQueries = useDistributionPercentilers(dClass, keys);
  const responses = new Map(
    keys.map((key, index) => {
      const query = distributionPercentilerQueries[index];
      const percentiler = query.data;
      const score = scores.get(key);
      const percentile = (() => {
        if (isNil(score) || isNil(percentiler)) {
          return undefined;
        }
        return percentiler.getPercentile(score);
      })();

      return [key, { score, distributionData: percentiler?.distribution, percentile }] as const;
    }),
  );

  return responses;
}
